SelectBox = exports

SelectBox.filter = (ids, data, selector, name_col = 'name', val_col = 'id', comp_col = 'id') ->

    if selector not instanceof jQuery
        selector = $(selector)

    # note: taffy objects aren't typed, they're generic functions instead
    if typeof data isnt 'function'
        data = TAFFY(data)

    # filter the data
    filter = {}
    filter[comp_col] = ids

    result = data(filter).select(val_col, name_col)

    SelectBox.render(result, selector)


# Gets a keyed array of objects into a usable state for rendering
SelectBox.prepareObject = (data, name_col = 'name', val_col = 'id') ->

    # format the data for rendering
    output = []

    for v, k in data
        output.push [v[val_col], v[name_col]]

    return output


SelectBox.render = (data, selector, first = [id: '', name: 'Select...'], trigger_change_event = true) ->

    if selector not instanceof jQuery
        selector = $(selector)

    old_val = selector.val()

    # empty select list
    selector.html('')

    # format the data for output
    output = first

    ids = []
    if data instanceof Array
        for v in data
            output.push
                id: v[0]
                name: v[1]
            ids.push v[0]
    else
        for k, v of data
            output.push
                id: k
                name: v
            ids.push k

    # render the html
    r = $('#gbl_option_tmpl').render(output)

    selector.html(r)

    # set the value of the dropdown
    if parseInt(old_val) in ids
        selector.val(old_val)

    else if old_val isnt ''
        selector.val('')
        selector.trigger('change') if trigger_change_event
